const state = {
    templates:[],
};

const getters = {
    getTemplates: state => state.templates,
};

const actions = {
    setTemplates: (store, payload) => store.commit("TEMPLATES_SET",payload),
};

const mutations = {
    TEMPLATES_SET: (state, payload) => state.templates = payload,
};

export default {
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};
